export const SystemCollision = () => {
  const setHasCrashed = useGameStore((state) => state.setHasCrashed);

  useFrame((state, delta) => {
    // PLAYER
    const player = players.entities[0];
    const playerPos = player.position;
    const playerSize = player.size;

    let isBlocked = false;

    const playerLeftLimit = playerPos.x - playerSize[0] * 0.5;
    const playerRightLimit = playerPos.x + playerSize[0] * 0.5;
    const playerTopLimit = playerPos.y + playerSize[1];
    const playerBottomLimit = playerPos.y;

    // OBSTACLES
    for (const entity of collidables) {
      const collidablePos = entity.position;
      const collidableSize = entity.size;
      const isStandable = entity.isStandable;
      const isBlocking = entity.isBlocking;
      const isCollided = entity.isCollided;
      const isCrashable = entity.isCrashable;

      const leftLimit = collidablePos.x - collidableSize[0] * 0.5;
      const rightLimit = collidablePos.x + collidableSize[0] * 0.5;

      const topLimit = collidablePos.y + collidableSize[1];
      const bottomLimit = collidablePos.y;

      const hitLeftSide = playerRightLimit >= leftLimit;
      const isAbove = playerBottomLimit > topLimit;
      const isBelow = playerTopLimit < bottomLimit;
      const pastLeftSide = playerRightLimit > leftLimit + 0.05;
      const pastRightSide = playerLeftLimit > rightLimit;

      if (
        !isCollided &&
        pastLeftSide &&
        !pastRightSide &&
        !isAbove &&
        !isBelow
      ) {
        ECS.world.addComponent(entity, 'isCollided', true);
        // if (isCrashable) {
        //   ECS.world.addComponent(entity, 'isCrashed', true);
        // }
      }
      if (
        hitLeftSide &&
        (!isStandable || !pastLeftSide) &&
        !pastRightSide &&
        !isAbove &&
        !isBelow
      ) {
        if (isCrashable) {
          ECS.world.addComponent(entity, 'isCrashed', true);
          setHasCrashed(true, entity.type);
        }
        ECS.world.addComponent(entity, 'isHit', true);
      }

      const isBlockedByThisObstacle =
        hitLeftSide && !isAbove && !isBelow && !pastLeftSide && isBlocking;

      isBlocked = isBlocked || isBlockedByThisObstacle;

      if (isBlockedByThisObstacle) {
        player.velocity.x = 0;
        player.position.x = leftLimit - playerSize[0] * 0.5;
      }

      if (pastLeftSide && !pastRightSide && isStandable) {
        player.position.y = Math.max(player.position.y, topLimit);

        const isOn = player.position.y <= topLimit;
        if (isOn) {
          // player.isJumping = false;
          if (player.isJumping) {
            console.log('SystemCollision.remove jumping');
            ECS.world.removeComponent(player, 'isJumping');
          }
          player.velocity.y = 0;
          player.position.y = topLimit;
        }
      }
    }

    // player.isBlocked = isBlocked;
    if (isBlocked) {
      ECS.world.addComponent(player, 'isBlocked', true);
    } else {
      ECS.world.removeComponent(player, 'isBlocked');
    }
  });

  return null;
};
